export function hasSellarCreditPaymentAttempt({
  twoOrder,
  hasPayment,
}: {
  twoOrder: { state: string } | null | undefined;
  hasPayment: boolean;
}) {
  return twoOrder ? twoOrder.state !== "pending" : hasPayment;
}
